/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
// @mui
import { Button, Container, Divider, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// layouts
import Layout from '../../layouts';
// components
import Page from '../../components/Page';

import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../components/Iconify';
import Markdown from '../../components/Markdown';
import useLocales from '../../hooks/useLocales';
import useSettings from '../../hooks/useSettings';
import { setExerciseSearch } from '../../redux/slices/hackerthon/hackerthon.exercise';
import ExerciseList from '../../sections/exercise/ExerciseList';
import { getTagBySlugAPI } from '../../service/hackerthon/hackerthon.tag.service';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
}));

// ----------------------------------------------------------------------

TagPage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function TagPage({ currentTag }) {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { search } = useSelector((state) => state.hackerthonExercise);

  useEffect(() => {
    dispatch(setExerciseSearch({ ...search, tags: [currentTag], filterBys: { ...search.filterBys, tagIds: `${currentTag.id}` } }));
    return () => {
      dispatch(setExerciseSearch({ ...search, tags: [], filterBys: { ...search.filterBys, tagIds: null } }));
    };
  }, [currentTag]);

  return (
    <Page title={currentTag.title} description={currentTag.metaDescription}
      imagePath={currentTag.featureImage}>
      <RootStyle>
        <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
          <Grid container spacing={1} >
            <Grid item xs={12} md={12}>
              <TagDetail tag={currentTag} />
              <ExerciseList />
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page>
  );
}

function TagDetail({ tag: { title, description } }) {
  const router = useRouter();
  const { translate } = useLocales();

  return (
    <Grid container spacing={2} mb={1}>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h5">{title}</Typography>
          <Button onClick={router.back} startIcon={
            <Iconify width={25} height={25} icon={'solar:arrow-left-broken'} />
          }><Typography variant="body2">{translate("button.goBack")}</Typography></Button>
        </Stack>
        <Divider />
      </Grid>
      <Grid item xs={12} >
        <Markdown children={description} />
      </Grid>
    </Grid>
  );
}

export async function getStaticPaths() {
  const paths = [{ params: { slug: '/school' }, }];
  return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params: { slug } }) {
  const { code, data: currentTag } = await getTagBySlugAPI(slug);

  if (code !== '200') {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      currentTag,
    },
  };
}
